import { useState, useEffect } from 'react';
import { isEmpty } from 'lodash';
import { getAllProperties } from '../services';

function useProperties() {
  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isEmpty(properties)) {
      setLoading(true);
      getAllProperties()
        .then(({ data }) => {
          setLoading(false);
          setProperties(data.items);
        })
        .catch(() => {
          setLoading(false);
        });
    }
  }, [properties]);

  return { properties, loading };
}

export default useProperties;
